module.exports = __webpack_public_path__ + "img/bind-failed-copy.41608dab.png";